/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Program } from "./Program";
export const ProgramsResponse = core.serialization.object({
    data: core.serialization.list(Program),
});
